import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormTextField } from "../../../../../components/fields";
import { RentalType } from "../../../../../types";
import { IFormValues } from "../../../../insert/types";
import {
    FormRentalType,
    FormCustomerCode,
    FormPickupLocation,
    FormDropoffLocation,
    FormPickupDate,
    FormDropoffDate,
    FormVehicleCategory,
    FormCarGroup,
    FormLockGroup,
    FormMileageIncluded,
    FormCig
} from "./fields";
import { useRecoilValue } from "recoil";
import {editBusinessAgreementCig} from "../../../recoil";
import TenantForm from "../../../../../components/multitenant/TenantForm";
import DealerForm from "../../../../../components/multitenant/DealerForm";
import {useContext} from "react";
import {GlobalContext} from "../../../../../../../util/state/GlobalContextProvider";

const BasicDetails = () => {

    const { t } = useTranslation('booking');
    const { globalData } = useContext(GlobalContext);
    const rentalType = useWatch<IFormValues, 'basicDetails.rentalType'>({
        name: 'basicDetails.rentalType'
    });

    const hasCig = useRecoilValue<boolean | undefined>(editBusinessAgreementCig);

    return (
        <Card>
            <CardHeader title={t('label.mainDetails')} />
            <CardContent>
                <Grid container rowSpacing={1} columnSpacing={3}>
                    {
                        !(globalData?.user.legalEntities.length === 1 && globalData?.user.dealers.length === 1) &&
                        <Grid item xs={12} lg={6} sm={6}>

                            <TenantForm
                                name={"basicDetails.tenant"}
                                multiple={false}
                                disabled={true}
                            />
                        </Grid>
                    }
                    {
                        !(globalData?.user.legalEntities.length === 1 && globalData?.user.dealers.length === 1) &&
                        <Grid item xs={12} lg={6} sm={6}>
                            <DealerForm
                                name={"basicDetails.dealer"}
                                multiple={false}
                                disabled={true}
                            />
                        </Grid>
                    }

                    <Grid container item columnSpacing={3} rowSpacing={2}>
                        <Grid container item xs={12} alignItems="center" columnGap={4}>
                            <FormRentalType />
                        </Grid>
                    </Grid>
                    {(rentalType === RentalType.CORPORATE) &&
                    <Grid container item columnSpacing={3} rowSpacing={2}>
                        <Grid item xs={12} sm={6}>
                            <FormCustomerCode />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormTextField<IFormValues>
                                name="basicDetails.dossierNumber"
                                label={t('label.dossierNumber')}
                            />
                        </Grid>
                                                     { hasCig &&
                                <>
                                    <Grid item xs={12} sm={6}>
                                        <FormCig  />
                                    </Grid>
                                </>
                            }
                    </Grid>
                    }
                    <Grid item xs={12} sm={6}>
                        <FormPickupLocation />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormDropoffLocation />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormPickupDate />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormDropoffDate />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormVehicleCategory />
                    </Grid>
                    <Grid container item xs={12} sm={6} columnGap={2} alignItems="start" flexWrap="nowrap" mt={1}>
                        <Grid item xs>
                            <FormCarGroup />
                        </Grid>
                        <Grid container item xs="auto" mt={1}>
                            <FormLockGroup />
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <FormMileageIncluded />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default BasicDetails;
